export const TECH_FOLDERS = ["Ficha Diseño", "Ficha Técnica", "3D", "Patrones"];

export const sanitizeBaseName = (value = "") =>
  value
    .toString()
    .trim()
    .replace(/[\\/:*?"<>|]/g, "-")
    .replace(/\s+/g, " ")
    .replace(/\.+$/, "");

const getFileExtension = (fileName = "") => {
  const lastDot = fileName.lastIndexOf(".");
  return lastDot >= 0 ? fileName.slice(lastDot) : "";
};

const escapeRegex = (value = "") =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const buildRenamedFile = (file, baseName, existingFiles = []) => {
  if (!file) return null;

  const safeBaseName = sanitizeBaseName(baseName) || "archivo";
  const regex = new RegExp(`^${escapeRegex(safeBaseName)}-(\\d+)`, "i");

  const maxCounter = existingFiles.reduce((max, existingFile) => {
    const match = existingFile?.name?.match(regex);
    if (!match) return max;
    const num = parseInt(match[1], 10);
    return Number.isNaN(num) ? max : Math.max(max, num);
  }, 0);

  const extension = getFileExtension(file.name);
  const nextCounter = String(maxCounter + 1).padStart(2, "0");
  const newName = `${safeBaseName}-${nextCounter}${extension}`;

  return new File([file], newName, {
    type: file.type,
    lastModified: file.lastModified,
  });
};

export const buildTechnicalUploadBaseName = ({
  clientName = "",
  designName = "",
} = {}) => {
  const safeClient = sanitizeBaseName(clientName);
  const safeDesign = sanitizeBaseName(designName);
  if (safeClient && safeDesign) return `${safeClient}-${safeDesign}`;
  return safeClient || safeDesign || "diseno";
};
